export const comics = [
  {
    id: 'comic-001',
    title: '剑尊归来',
    slug: 'sword-master-returns',
    author: '李浩延',
    category: '热血',
    rating: 4.9,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20a%20powerful%20swordsman%20in%20traditional%20martial%20arts%20robe%2C%20dramatic%20dynamic%20pose%20holding%20a%20gleaming%20sword%2C%20atmospheric%20lighting%20with%20dust%20particles%2C%20vibrant%20warm%20orange%20and%20red%20color%20palette%2C%20clean%20simple%20background%2C%20anime%20manhwa%20style%20illustration%2C%20high%20contrast%2C%20detailed%20character%20design&width=800&height=1120&seq=comic-cover-01&orientation=portrait',
    description: '天下第一剑尊在击败魔帝后陨落，却意外重生回到二十年前。带着前世的记忆与剑术，他将重写命运，踏上全新的修行之路。江湖风云再起，这一次，他将守护所有重要的人。',
    status: '连载中',
    updatedAt: '2026-07-03',
    chapters: 187,
    views: 3250000,
    tags: ['重生', '武侠', '热血', '爽文'],
  },
  {
    id: 'comic-002',
    title: '我独自升级',
    slug: 'solo-leveling',
    author: 'Chugong',
    category: '热血',
    rating: 4.8,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%2C%20a%20mysterious%20dark-haired%20warrior%20with%20glowing%20purple%20eyes%2C%20shadow%20army%20rising%20behind%20him%2C%20dark%20atmospheric%20background%20with%20smoke%20and%20shadows%2C%20cool%20blue%20and%20black%20color%20scheme%2C%20clean%20simple%20composition%2C%20anime%20manhwa%20illustration%20style%2C%20high%20detail&width=800&height=1120&seq=comic-cover-02&orientation=portrait',
    description: '在一个突然出现"传送门"和"猎人"的世界里，E级猎人成振宇在一次双重地下城事故中濒死，却意外获得了"系统"的力量。从最弱到最强，他的崛起之路就此展开。',
    status: '已完结',
    updatedAt: '2026-06-28',
    chapters: 179,
    views: 12800000,
    tags: ['系统', '升级', '猎人', '暗影'],
  },
  {
    id: 'comic-003',
    title: '女神降临',
    slug: 'true-beauty',
    author: 'Yaongyi',
    category: '恋爱',
    rating: 4.7,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%2C%20beautiful%20young%20woman%20with%20long%20dark%20hair%20and%20elegant%20makeup%2C%20soft%20dreamy%20expression%2C%20pastel%20pink%20and%20cream%20background%20with%20floating%20flower%20petals%2C%20clean%20romantic%20aesthetic%2C%20shojo%20manhwa%20art%20style%2C%20delicate%20and%20charming&width=800&height=1120&seq=comic-cover-03&orientation=portrait',
    description: '因为相貌被嘲笑的女高中生林周京，通过化妆技术实现了华丽变身。在新学校里，她成为了众人眼中的女神，但她的秘密随时可能被揭穿。一段关于自信和真爱的青春故事。',
    status: '已完结',
    updatedAt: '2026-06-25',
    chapters: 208,
    views: 9600000,
    tags: ['校园', '恋爱', '化妆', '青春'],
  },
  {
    id: 'comic-004',
    title: '全知读者视角',
    slug: 'omniscient-reader',
    author: 'sing N song',
    category: '奇幻',
    rating: 4.9,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%2C%20a%20young%20man%20with%20round%20glasses%20holding%20a%20glowing%20ancient%20book%2C%20apocalyptic%20cityscape%20background%20with%20floating%20constellations%2C%20dramatic%20golden%20and%20teal%20lighting%2C%20clean%20composition%2C%20detailed%20anime%20manhwa%20illustration%20style&width=800&height=1120&seq=comic-cover-04&orientation=portrait',
    description: '独子是一个普通上班族，唯一的乐趣就是阅读一部连载了十年的网络小说。当这部小说终于完结的那一天，小说中的世界竟然变成了现实。而作为唯一知道结局的人，他的选择将改变一切。',
    status: '连载中',
    updatedAt: '2026-07-02',
    chapters: 215,
    views: 7800000,
    tags: ['穿越', '末世', '系统', '剧情'],
  },
  {
    id: 'comic-005',
    title: '再婚皇后',
    slug: 'remarried-empress',
    author: 'Alpha Tart',
    category: '恋爱',
    rating: 4.8,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20romance%20cover%2C%20elegant%20empress%20in%20luxurious%20golden%20gown%20and%20crown%2C%20standing%20in%20a%20palace%20throne%20room%2C%20regal%20and%20dignified%20expression%2C%20warm%20golden%20and%20crimson%20palette%2C%20clean%20simple%20background%2C%20detailed%20manhwa%20art%20style%2C%20noble%20atmosphere&width=800&height=1120&seq=comic-cover-05&orientation=portrait',
    description: '娜维埃是东方帝国的皇后，她的丈夫——皇帝索维舒却公开带着情人出席各种场合。面对丈夫的背叛，娜维埃做出了一个震惊所有人的决定：她同意了离婚，并宣布自己将再婚。',
    status: '已完结',
    updatedAt: '2026-06-20',
    chapters: 162,
    views: 6500000,
    tags: ['宫廷', '恋爱', '逆袭', '女性向'],
  },
  {
    id: 'comic-006',
    title: '诡秘之主',
    slug: 'lord-of-mysteries',
    author: '爱潜水的乌贼',
    category: '悬疑',
    rating: 4.7,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20cover%2C%20a%20mysterious%20figure%20in%20victorian%20era%20coat%20and%20top%20hat%2C%20half%20face%20hidden%20in%20shadows%2C%20holding%20a%20pocket%20watch%20with%20strange%20symbols%2C%20foggy%20London%20street%20background%2C%20dark%20moody%20sepia%20tone%2C%20clean%20composition%2C%20detailed%20manhwa%20illustration&width=800&height=1120&seq=comic-cover-06&orientation=portrait',
    description: '周明瑞穿越到了蒸汽与机械的奇幻世界，成为了一个普通的历史系大学生克莱恩·莫雷蒂。在这个充满超凡力量、隐秘组织和古老神灵的世界里，他必须小心翼翼地维持自己的"人性"，同时追寻回家的方法。',
    status: '连载中',
    updatedAt: '2026-07-01',
    chapters: 198,
    views: 5400000,
    tags: ['穿越', '悬疑', '克苏鲁', '蒸汽朋克'],
  },
  {
    id: 'comic-007',
    title: '公爵的契约未婚妻',
    slug: 'dukes-contract-fiancee',
    author: 'Milcha',
    category: '恋爱',
    rating: 4.6,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20fantasy%20cover%2C%20beautiful%20noblewoman%20in%20elegant%20blue%20gown%20with%20silver%20hair%2C%20standing%20beside%20a%20handsome%20duke%20in%20black%20formal%20attire%2C%20romantic%20moonlit%20garden%20background%2C%20soft%20silver%20and%20blue%20palette%2C%20clean%20composition%2C%20detailed%20manhwa%20art%20style&width=800&height=1120&seq=comic-cover-07&orientation=portrait',
    description: '穿越成小说中的配角后，莱利娜为了摆脱悲惨的命运，主动找到冷酷的诺亚公爵提出契约婚姻。她以为自己只是在利用他，却不知道公爵早已看穿一切，并默默守护着她。',
    status: '已完结',
    updatedAt: '2026-06-15',
    chapters: 145,
    views: 4200000,
    tags: ['穿越', '恋爱', '宫廷', '契约婚姻'],
  },
  {
    id: 'comic-008',
    title: '神之塔',
    slug: 'tower-of-god',
    author: 'SIU',
    category: '奇幻',
    rating: 4.8,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20adventure%20cover%2C%20a%20young%20boy%20climbing%20a%20massive%20mysterious%20tower%20reaching%20into%20the%20clouds%2C%20holding%20a%20glowing%20orb%2C%20fantastical%20and%20magical%20surroundings%20with%20floating%20islands%2C%20vibrant%20blue%20and%20gold%20color%20scheme%2C%20clean%20composition%2C%20detailed%20anime%20manhwa%20style&width=800&height=1120&seq=comic-cover-08&orientation=portrait',
    description: '二十五夜为了追寻唯一的朋友蕾哈尔，进入了一座神秘的高塔。在这座塔的每一层都存在着不同的世界和考验，他必须不断变强才能攀登到塔顶。塔的秘密和真相，将一步步揭晓。',
    status: '连载中',
    updatedAt: '2026-07-02',
    chapters: 590,
    views: 15000000,
    tags: ['冒险', '奇幻', '塔', '战斗'],
  },
  {
    id: 'comic-009',
    title: '入赘女婿',
    slug: 'the-son-in-law',
    author: '金龙泽',
    category: '热血',
    rating: 4.5,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%2C%20a%20young%20man%20in%20modern%20black%20suit%20with%20cold%20determined%20expression%2C%20holding%20a%20briefcase%2C%20corporate%20building%20background%20with%20dramatic%20lighting%2C%20dark%20blue%20and%20silver%20color%20palette%2C%20clean%20composition%2C%20detailed%20manhwa%20illustration%20style%2C%20urban%20atmosphere&width=800&height=1120&seq=comic-cover-09&orientation=portrait',
    description: '入赘三年的女婿受尽白眼和屈辱，直到某天他的真实身份被揭开——他竟是隐藏的财阀继承人。从此，那些曾经看不起他的人将付出代价。一场酣畅淋漓的逆袭大戏。',
    status: '连载中',
    updatedAt: '2026-06-30',
    chapters: 123,
    views: 3800000,
    tags: ['都市', '逆袭', '财阀', '爽文'],
  },
  {
    id: 'comic-010',
    title: '废太子求生记',
    slug: 'banished-prince',
    author: '金浩民',
    category: '奇幻',
    rating: 4.6,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20fantasy%20cover%2C%20a%20young%20prince%20in%20traditional%20royal%20robes%20standing%20in%20a%20snowy%20wilderness%2C%20holding%20a%20magical%20staff%2C%20determined%20expression%2C%20cold%20winter%20atmosphere%20with%20falling%20snow%2C%20silver%20and%20ice%20blue%20palette%2C%20clean%20composition%2C%20detailed%20manhwa%20art%20style&width=800&height=1120&seq=comic-cover-10&orientation=portrait',
    description: '太子被废黜流放至极寒之地，所有人都以为他必死无疑。但他在绝境中觉醒了隐藏的魔力，以废太子之身重新崛起。他要夺回属于自己的一切，向那些背叛者复仇。',
    status: '连载中',
    updatedAt: '2026-06-29',
    chapters: 156,
    views: 4100000,
    tags: ['宫廷', '复仇', '魔法', '逆袭'],
  },
  {
    id: 'comic-011',
    title: '甜蜜的陷阱',
    slug: 'sweet-trap',
    author: '韩素熙',
    category: '恋爱',
    rating: 4.7,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%2C%20couple%20sitting%20in%20a%20cozy%20cafe%20with%20warm%20lighting%2C%20young%20man%20and%20woman%20looking%20at%20each%20other%20with%20gentle%20smiles%2C%20coffee%20cups%20on%20table%2C%20soft%20brown%20and%20cream%20color%20palette%2C%20clean%20romantic%20composition%2C%20detailed%20manhwa%20art%20style&width=800&height=1120&seq=comic-cover-11&orientation=portrait',
    description: '咖啡店老板姜智雅遇到了常客——一个总是点同一杯咖啡的神秘男人。她不知不觉地陷入了他的温柔陷阱中。但这段甜蜜关系的背后，似乎隐藏着一个惊人的秘密。',
    status: '连载中',
    updatedAt: '2026-07-01',
    chapters: 89,
    views: 2100000,
    tags: ['都市', '恋爱', '悬疑', '甜宠'],
  },
  {
    id: 'comic-012',
    title: '地下城重置',
    slug: 'dungeon-reset',
    author: 'DAUL',
    category: '热血',
    rating: 4.6,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20dungeon%20fantasy%20cover%2C%20a%20young%20adventurer%20with%20shield%20and%20hammer%20in%20a%20dark%20underground%20dungeon%2C%20glowing%20crystals%20on%20walls%2C%20monster%20shadow%20in%20background%2C%20warm%20orange%20torchlight%20contrasting%20with%20dark%20cave%2C%20clean%20composition%2C%20detailed%20manhwa%20illustration&width=800&height=1120&seq=comic-cover-12&orientation=portrait',
    description: '被卷入地下城生存游戏后，郑大云发现自己拥有一个独特的能力——可以重置地下城。利用这个能力，他不断探索、建造和生存，逐渐揭开了这个游戏的真相。',
    status: '连载中',
    updatedAt: '2026-06-28',
    chapters: 134,
    views: 2900000,
    tags: ['地下城', '生存', '建造', '奇幻'],
  },
];

export const featuredComics = comics.slice(0, 6);
export const popularComics = comics.slice(0, 9);
export const latestComics = [...comics].sort(() => Math.random() - 0.5).slice(0, 9);